import { supabase } from './supabase';
import {
  DEFAULT_VISIT_DURATION_BY_TYPE,
  VisitDurationDefaults,
  VisitType,
  isValidVisitDurationMinutes,
} from './visitDuration';

type VisitDurationDefaultRow = {
  visit_type: VisitType;
  duration_minutes: number;
};

export const isMissingVisitDurationDefaultsTableError = (error: any) =>
  error?.code === '42P01' || String(error?.message || '').includes('visit_duration_defaults');

export const getFallbackVisitDurationDefaults = (): VisitDurationDefaults => ({
  ...DEFAULT_VISIT_DURATION_BY_TYPE,
});

export const normalizeVisitDurationDefaults = (
  rows: VisitDurationDefaultRow[] | null | undefined,
): VisitDurationDefaults => {
  const defaults = getFallbackVisitDurationDefaults();
  (rows || []).forEach((row) => {
    if (row?.visit_type && isValidVisitDurationMinutes(row.duration_minutes)) {
      defaults[row.visit_type] = row.duration_minutes;
    }
  });
  return defaults;
};

export const loadVisitDurationDefaults = async (): Promise<VisitDurationDefaults> => {
  const { data, error } = await supabase
    .from('visit_duration_defaults')
    .select('visit_type, duration_minutes')
    .in('visit_type', ['maintenance', 'service', 'walkthrough']);

  if (error) {
    if (isMissingVisitDurationDefaultsTableError(error)) {
      return getFallbackVisitDurationDefaults();
    }
    throw error;
  }
  return normalizeVisitDurationDefaults(data as VisitDurationDefaultRow[] | null);
};
